import { iconsList } from './iconsList';
/**
 * import SVG sprite from CDN/external source or create one and append to the body
 * provide a URL to load svg sprite from 3rd party source
 * if source wasn't available, load defaults from iconsList file
 */
export const addIcons = (url = '') => {
    const svgContainer = document.createElement('div');
    svgContainer.id = 'svg-container';
    svgContainer.style.display = 'none';
    if (url) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.onload = () => {
            svgContainer.innerHTML = xhr.responseText;
            document.body.appendChild(svgContainer);
        };
        xhr.onerror = () => {
            console.error('Error: Failed to load icons from CDN, defaults loaded.');
            svgContainer.appendChild(makeSvgSprite());
            document.body.appendChild(svgContainer);
        };
        xhr.send();
    }
    else {
        svgContainer.appendChild(makeSvgSprite());
        document.body.appendChild(svgContainer);
    }
};
const xmlns = 'http://www.w3.org/2000/svg';
const makeSvgSprite = () => {
    const svg = document.createElementNS(xmlns, 'svg');
    svg.setAttribute('xmlns', xmlns);
    svg.style.display = 'none';
    iconsList.forEach(({ id, viewBox, d }) => {
        const symbol = createSymbol(xmlns, id, viewBox);
        if (Array.isArray(d)) {
            d.forEach(pathItem => {
                const path = createComplexPath(xmlns, pathItem);
                symbol.appendChild(path);
            });
        }
        else {
            const path = createPath(xmlns, d);
            symbol.appendChild(path);
        }
        svg.appendChild(symbol);
    });
    return svg;
};
const createSymbol = (xmlns, id, viewBox) => {
    const symbol = document.createElementNS(xmlns, 'symbol');
    symbol.id = id;
    symbol.setAttribute('viewBox', viewBox);
    return symbol;
};
const createPath = (xmlns, d) => {
    const path = document.createElementNS(xmlns, 'path');
    path.setAttribute('d', d);
    return path;
};
const createComplexPath = (xmlns, pathItem) => {
    const g = document.createElementNS(xmlns, 'g');
    const path = document.createElementNS(xmlns, 'path');
    path.setAttribute('d', pathItem.path);
    if (pathItem.fill) {
        g.setAttribute('fill', pathItem.fill);
    }
    g.appendChild(path);
    return g;
};
//# sourceMappingURL=icons.js.map